/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Forside_Carousel_PositionInputs */

const da_forside_carousel_position = /** @type {(inputs: Forside_Carousel_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.current} af ${i?.total}`)
};

/** @type {(inputs: Forside_Carousel_PositionInputs) => LocalizedString} */
const en_forside_carousel_position = da_forside_carousel_position;

/**

* @param {Forside_Carousel_PositionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_carousel_position = /** @type {((inputs: Forside_Carousel_PositionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Carousel_PositionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_carousel_position(inputs)
	return da_forside_carousel_position(inputs)
});